import React from 'react';
import { observer } from 'mobx-react';

import { Discount } from '../discount';
import { useToast } from 'core/components/toast';
import { track } from 'core/helpers/analytics';
import { useStore } from 'core/store/';

const BundleDiscount = ({ isActive, ...discount }) => {
  const toast = useToast();
  const {
    offer: {
      offer: {
        id,
        quote: {
          correctedAddress: { state }
        }
      }
    }
  } = useStore();

  const onAddClick = () => {
    document.getElementById('selectedOption').scrollIntoView({ block: 'center', behavior: 'smooth' });
    toast.notify({
      type: 'info',
      message: 'Change your policy selection to dwelling and auto to apply the bundle discount.'
    });
    track('Bundle Discount Added', {
      discount: discount.label,
      offerId: id,
      state
    });
  };

  return <Discount {...discount} isActive={isActive} onAdd={onAddClick} />;
};

export default observer(BundleDiscount);
